// Иконка скрепки — кнопка прикрепить файл.
import React from "react";

export function PaperclipIcon({ size = 24, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke={color} strokeWidth="1.8"
         strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 11.5 12 18.5a4 4 0 0 1-5.7-5.7l8.5-8.5a2.8 2.8 0 0 1 4 4L10 17a1.5 1.5 0 0 1-2-2l7-7" />
    </svg>
  );
}

export default PaperclipIcon;
